import { Card } from '@iwoca/orion';
import Skeleton from 'react-loading-skeleton';
import { connect } from 'react-redux';

import 'react-loading-skeleton/dist/skeleton.css';
import { useRedirectHandler } from '@src/hooks/useRedirectHandler';
import { RootState } from '@src/reducers';

import styles from './RouteLoader.module.css';

const mapStateToProps = (state: RootState) => ({
    furthestStepId: state.ui.furthestStep?.id,
    isApplicationStateLoading: state.fetched.application.loading
});

const RouteLoader = ({
    furthestStepId,
    isApplicationStateLoading
}: ReturnType<typeof mapStateToProps>) => {
    const isLoading = useRedirectHandler(
        furthestStepId,
        isApplicationStateLoading
    );

    if (!isLoading) return null;

    return (
        <Card
            className={styles.routerLoaderContainer}
            data-testid="route-loader">
            <Skeleton
                containerClassName={styles.skeletonContainer}
                baseColor="var(--color-structure-80)"
                width="100%"
                height={24}
            />
        </Card>
    );
};

export default connect(mapStateToProps)(RouteLoader);
